import { render, staticRenderFns } from "./PixelTable.vue?vue&type=template&id=4f81c510&scoped=true&"
import script from "./PixelTable.vue?vue&type=script&lang=js&"
export * from "./PixelTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f81c510",
  null
  
)

export default component.exports